export enum ViewTileType {
  Properties = 'properties',
  MajorProperties = 'major-properties',
  Paragraphy = 'paragraph',
  RailMap = 'rail-map',
}